var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapshotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H2v3H1V1h4zm14 0h3v3h1V1h-4zM2 19H1v4h4v-1H2zm20 3h-3v1h4v-4h-1zm-3-3H6v-2h1v1h1V6H7v1H6V5h13zM18 6H9v12h9zM7 8H6v1H5v1h2zm0 3H6v1H5v1h2zm0 3H6v1H5v1h2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshotIcon);
export default __webpack_public_path__ + "static/media/SnapshotIcon.dedf324287867c236e3f6ee8a329ef96.svg";
export { ForwardRef as ReactComponent };